"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _styledComponents = require("styled-components");

var _theme = require("@input-output-hk/front-end-core-libraries/build/theme");

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  html {\n    max-width: 100%;\n    overflow-x: hidden;\n    background-color: ", ";\n    box-sizing: border-box;\n    font-size: 62.5%;\n  }\n\n  *,\n  *:before,\n  *:after {\n    box-sizing:inherit;\n  }\n\n  hr {\n    height: 0.1rem;\n    color: ", ";\n    background-color: ", ";\n    border: none;\n  }\n\n  body {\n    color: ", ";\n    margin: 0;\n    background-color: ", ";\n    -ms-overflow-style: -ms-autohiding-scrollbar;\n    min-height: 100vh;\n  }\n\n  body,\n  input,\n  textarea {\n    font-family: ", ";\n    font-size: ", ";\n    font-weight: ", ";\n    line-height: ", ";\n    letter-spacing: ", ";\n    text-transform: ", ";\n    ", "\n  }\n\n  h1 {\n    font-family: ", ";\n    font-size: ", ";\n    font-weight: ", ";\n    line-height: ", ";\n    letter-spacing: ", ";\n    text-transform: ", ";\n    ", "\n  }\n\n  h2 {\n    font-family: ", ";\n    font-size: ", ";\n    font-weight: ", ";\n    line-height: ", ";\n    letter-spacing: ", ";\n    text-transform: ", ";\n    ", "\n  }\n\n  h3 {\n    font-family: ", ";\n    font-size: ", ";\n    font-weight: ", ";\n    line-height: ", ";\n    letter-spacing: ", ";\n    text-transform: ", ";\n    ", "\n  }\n\n  h4 {\n    font-family: ", ";\n    font-size: ", ";\n    font-weight: ", ";\n    line-height: ", ";\n    letter-spacing: ", ";\n    text-transform: ", ";\n    ", "\n  }\n\n  h5 {\n    font-family: ", ";\n    font-size: ", ";\n    font-weight: ", ";\n    line-height: ", ";\n    letter-spacing: ", ";\n    text-transform: ", ";\n    ", "\n  }\n\n  h6 {\n    font-family: ", ";\n    font-size: ", ";\n    font-weight: ", ";\n    line-height: ", ";\n    letter-spacing: ", ";\n    text-transform: ", ";\n    ", "\n  }\n\n  small {\n    color: ", ";\n  }\n\n  ul,\n  ol {\n    list-style-position: inside;\n    margin-left:0;\n    padding: 0;\n  }\n\n  a {\n    outline-width: 0.5rem;\n    color: ", ";\n    transition: color 0.1s ease-in-out;\n    text-decoration: none;\n\n    &:hover {\n      color: ", ";\n    }\n  }\n\n  img {\n    max-width: 100%;\n    height: auto;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2["default"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function getProperty(key) {
  return key.replace(/([A-Z])/g, function (_, upper) {
    return "-".concat(upper.toLowerCase());
  });
}

function getResponsiveFontCSS(font, baseFontSize, defaultLetterSpacing) {
  var baseCSS = '';
  var excludedKeys = ['font-family', 'font-size', 'font-weight', 'line-height', 'letter-spacing', 'text-transform'];
  var responsiveKeys = [];
  Object.keys(font).forEach(function (key) {
    if (key.match(/^@/)) {
      responsiveKeys.push(key);
    } else if (!excludedKeys.includes(key)) {
      baseCSS += "".concat(getProperty(key), ": ").concat(font[key], ";");
    }
  });
  var responsiveConfig = {};
  responsiveKeys.forEach(function (key) {
    responsiveConfig[key] = _objectSpread({}, font[key]);
    if (responsiveConfig[key].fontSize !== undefined) responsiveConfig[key].fontSize = (0, _theme.getFontSize)(responsiveConfig[key].fontSize, baseFontSize);
    if (responsiveConfig[key].letterSpacing !== undefined) responsiveConfig[key].letterSpacing = (0, _theme.getLetterSpacing)(responsiveConfig[key].letterSpacing, defaultLetterSpacing);
  });
  var responsiveCSS = Object.keys(responsiveConfig).map(function (query) {
    var styles = Object.keys(responsiveConfig[query]).map(function (key) {
      return "".concat(getProperty(key), ": ").concat(responsiveConfig[query][key], ";");
    }).join('');
    return "".concat(query, " { ").concat(styles, " }");
  }).join('');
  return "".concat(baseCSS).concat(responsiveCSS);
}

function getNumericValue(value, defaultValue) {
  if (value === undefined || value === null) return defaultValue;
  return value;
}

var _default = (0, _styledComponents.createGlobalStyle)(_templateObject(), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.background["default"];
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.text.primary;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.text.primary;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.text.primary;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.background["default"];
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.typography.body.fontFamily || theme.typography.fontFamily;
}, function (_ref7) {
  var theme = _ref7.theme;
  return (0, _theme.getFontSize)(theme.typography.body.fontSize, theme.typography.baseFontSize);
}, function (_ref8) {
  var theme = _ref8.theme;
  return getNumericValue(theme.typography.body.fontWeight, theme.typography.fontWeight);
}, function (_ref9) {
  var theme = _ref9.theme;
  return getNumericValue(theme.typography.body.lineHeight, theme.typography.lineHeight);
}, function (_ref10) {
  var theme = _ref10.theme;
  return (0, _theme.getLetterSpacing)(theme.typography.body.letterSpacing, theme.typography.letterSpacing);
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.typography.body.textTransform || theme.typography.textTransform;
}, function (_ref12) {
  var theme = _ref12.theme;
  return getResponsiveFontCSS(theme.typography.body, theme.typography.baseFontSize);
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.typography.h1.fontFamily || theme.typography.fontFamily;
}, function (_ref14) {
  var theme = _ref14.theme;
  return (0, _theme.getFontSize)(theme.typography.h1.fontSize, theme.typography.baseFontSize);
}, function (_ref15) {
  var theme = _ref15.theme;
  return getNumericValue(theme.typography.h1.fontWeight, theme.typography.fontWeight);
}, function (_ref16) {
  var theme = _ref16.theme;
  return getNumericValue(theme.typography.h1.lineHeight, theme.typography.lineHeight);
}, function (_ref17) {
  var theme = _ref17.theme;
  return (0, _theme.getLetterSpacing)(theme.typography.h1.letterSpacing, theme.typography.letterSpacing);
}, function (_ref18) {
  var theme = _ref18.theme;
  return theme.typography.h1.textTransform || theme.typography.textTransform;
}, function (_ref19) {
  var theme = _ref19.theme;
  return getResponsiveFontCSS(theme.typography.h1, theme.typography.baseFontSize);
}, function (_ref20) {
  var theme = _ref20.theme;
  return theme.typography.h2.fontFamily || theme.typography.fontFamily;
}, function (_ref21) {
  var theme = _ref21.theme;
  return (0, _theme.getFontSize)(theme.typography.h2.fontSize, theme.typography.baseFontSize);
}, function (_ref22) {
  var theme = _ref22.theme;
  return getNumericValue(theme.typography.h2.fontWeight, theme.typography.fontWeight);
}, function (_ref23) {
  var theme = _ref23.theme;
  return getNumericValue(theme.typography.h2.lineHeight, theme.typography.lineHeight);
}, function (_ref24) {
  var theme = _ref24.theme;
  return (0, _theme.getLetterSpacing)(theme.typography.h2.letterSpacing, theme.typography.letterSpacing);
}, function (_ref25) {
  var theme = _ref25.theme;
  return theme.typography.h2.textTransform || theme.typography.textTransform;
}, function (_ref26) {
  var theme = _ref26.theme;
  return getResponsiveFontCSS(theme.typography.h2, theme.typography.baseFontSize);
}, function (_ref27) {
  var theme = _ref27.theme;
  return theme.typography.h3.fontFamily || theme.typography.fontFamily;
}, function (_ref28) {
  var theme = _ref28.theme;
  return (0, _theme.getFontSize)(theme.typography.h3.fontSize, theme.typography.baseFontSize);
}, function (_ref29) {
  var theme = _ref29.theme;
  return getNumericValue(theme.typography.h3.fontWeight, theme.typography.fontWeight);
}, function (_ref30) {
  var theme = _ref30.theme;
  return getNumericValue(theme.typography.h3.lineHeight, theme.typography.lineHeight);
}, function (_ref31) {
  var theme = _ref31.theme;
  return (0, _theme.getLetterSpacing)(theme.typography.h3.letterSpacing, theme.typography.letterSpacing);
}, function (_ref32) {
  var theme = _ref32.theme;
  return theme.typography.h3.textTransform || theme.typography.textTransform;
}, function (_ref33) {
  var theme = _ref33.theme;
  return getResponsiveFontCSS(theme.typography.h3, theme.typography.baseFontSize);
}, function (_ref34) {
  var theme = _ref34.theme;
  return theme.typography.h4.fontFamily || theme.typography.fontFamily;
}, function (_ref35) {
  var theme = _ref35.theme;
  return (0, _theme.getFontSize)(theme.typography.h4.fontSize, theme.typography.baseFontSize);
}, function (_ref36) {
  var theme = _ref36.theme;
  return getNumericValue(theme.typography.h4.fontWeight, theme.typography.fontWeight);
}, function (_ref37) {
  var theme = _ref37.theme;
  return getNumericValue(theme.typography.h4.lineHeight, theme.typography.lineHeight);
}, function (_ref38) {
  var theme = _ref38.theme;
  return (0, _theme.getLetterSpacing)(theme.typography.h4.letterSpacing, theme.typography.letterSpacing);
}, function (_ref39) {
  var theme = _ref39.theme;
  return theme.typography.h4.textTransform || theme.typography.textTransform;
}, function (_ref40) {
  var theme = _ref40.theme;
  return getResponsiveFontCSS(theme.typography.h4, theme.typography.baseFontSize);
}, function (_ref41) {
  var theme = _ref41.theme;
  return theme.typography.h5.fontFamily || theme.typography.fontFamily;
}, function (_ref42) {
  var theme = _ref42.theme;
  return (0, _theme.getFontSize)(theme.typography.h5.fontSize, theme.typography.baseFontSize);
}, function (_ref43) {
  var theme = _ref43.theme;
  return getNumericValue(theme.typography.h5.fontWeight, theme.typography.fontWeight);
}, function (_ref44) {
  var theme = _ref44.theme;
  return getNumericValue(theme.typography.h5.lineHeight, theme.typography.lineHeight);
}, function (_ref45) {
  var theme = _ref45.theme;
  return (0, _theme.getLetterSpacing)(theme.typography.h5.letterSpacing, theme.typography.letterSpacing);
}, function (_ref46) {
  var theme = _ref46.theme;
  return theme.typography.h5.textTransform || theme.typography.textTransform;
}, function (_ref47) {
  var theme = _ref47.theme;
  return getResponsiveFontCSS(theme.typography.h5, theme.typography.baseFontSize);
}, function (_ref48) {
  var theme = _ref48.theme;
  return theme.typography.h6.fontFamily || theme.typography.fontFamily;
}, function (_ref49) {
  var theme = _ref49.theme;
  return (0, _theme.getFontSize)(theme.typography.h6.fontSize, theme.typography.baseFontSize);
}, function (_ref50) {
  var theme = _ref50.theme;
  return getNumericValue(theme.typography.h6.fontWeight, theme.typography.fontWeight);
}, function (_ref51) {
  var theme = _ref51.theme;
  return getNumericValue(theme.typography.h6.lineHeight, theme.typography.lineHeight);
}, function (_ref52) {
  var theme = _ref52.theme;
  return (0, _theme.getLetterSpacing)(theme.typography.h6.letterSpacing, theme.typography.letterSpacing);
}, function (_ref53) {
  var theme = _ref53.theme;
  return theme.typography.h6.textTransform || theme.typography.textTransform;
}, function (_ref54) {
  var theme = _ref54.theme;
  return getResponsiveFontCSS(theme.typography.h6, theme.typography.baseFontSize);
}, function (_ref55) {
  var theme = _ref55.theme;
  return theme.colors.text.secondary;
}, function (_ref56) {
  var theme = _ref56.theme;
  return theme.colors.primary.main;
}, function (_ref57) {
  var theme = _ref57.theme;
  return theme.colors.primary.light;
});

exports["default"] = _default;